
const ACTION_SCOPE = '[Interviewer]';
export class SetInterviewerSearch {
    static readonly type = `${ACTION_SCOPE} Set Search Query`;
    constructor(public query: string) {}
}
export class GetInterviewers {
  static readonly type = `${ACTION_SCOPE} Get Interviewer`;
}

export class AddInterviewer {
  static readonly type = `${ACTION_SCOPE} Add Interviewer`;
  constructor(public payload: any) { }
}

export class UpdateInterviewer {
  static readonly type = `${ACTION_SCOPE} Update Interviewer`;
  constructor(public payload: any) { }
}

export class DeleteInterviewer {
  static readonly type = `${ACTION_SCOPE} Delete Interviewer`;
  constructor(public payload: any) { }
}
